export const debugId = () => new URLSearchParams(window.location.search).get('debugId') ?? import.meta.env.VITE_DEBUG_ID;
